import axios from 'axios';

/**
 * Fetches the list of client industries from the server
 * @returns {Promise<Array>} A promise that resolves to the list of companies
 */
export const fetchCompanies = async (search = '') => {
    try {
        const options = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/companies`,
            params: {}
        };
        if (search) {
            options.params.search = search;
        }

        const response = await axios(options);

        if (response.data.success && Array.isArray(response.data.data)) {
            return response.data.data.map(i => ({
                id: i.id,
                label: i.name,
                search: `${i.name} ${i.code}`
            }));
        }

        return [];
    } catch (error) {
        console.error('Error fetching companies:', error);
        return [];
    }
};
